import LogRocket from 'logrocket';
import BaseTracker, { PlatformProperty } from '../../../../packages/analytics/trackers/BaseTracker';

export const logRocketEventsList = [
  'search',
  'search_click',
  'client_proprofile_viewed',
  'pro_profile_limited_availability_pressed',
  'client_servicereview_clicked',
  'client_proprofile_book_click',
  'client_procalendar_clicked',
  'client_procalendar_time_clicked',
  'pro_bio_chat_clicked',
  'client_proprofile_tab_clicked',
  'client_proprofile_gallery_click',
  'client_book_confirmation_viewed',
  'client_notify_me_phone_viewed',
  'signin_and_signup_login_clicked',
  'user_model_login_succeeded',
  'user_model_login_failed',
  'user_model_signup_succeeded',
  'user_model_signup_failed',
  'client_appointment_booked',
  'client_guestbooking_summary_continueasguest_clicked',
];

export class LogRocketTracker extends BaseTracker {
  shouldTrack: boolean;

  constructor(env: string, platform: PlatformProperty, shouldTrackLogRocket: boolean) {
    super('LogRocket', 'Tracker (LogRocket)', env, platform);
    this.shouldTrack = shouldTrackLogRocket;
  }

  /**
   * Performs the actual tracking call.
   * @param {String} eventName The name of the event to track
   * @param properties
   * @returns {Promise} Resolves when the event has been logged.
   * */
  async trackEvent(eventName: string, properties: { [key: string]: any }) {
    if (this.shouldTrack && logRocketEventsList.includes(eventName)) {
      LogRocket.track(eventName, properties);
      this.debugLog('trackEvent', eventName, properties);
    }
  }
}
